import React, { useState, useEffect } from 'react';

// use: 
//  const isMobile = useIsMobile();
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(null);

  const handleWindowSizeChange = () => {
    const width = window.innerWidth;
    
    if (width < 768) {
      setIsMobile(1);
    } else {
      setIsMobile(0);
    }
  }

  useEffect(() => {
    if (window.navigator !== "undefined") {
      window.addEventListener('resize', handleWindowSizeChange);
      return handleWindowSizeChange();
    } else  {
      setIsMobile(0);
    }
    return () => {
      if (window.navigator !== "undefined") 
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  return isMobile;

}

export default useIsMobile;